import { render, staticRenderFns } from "./CourseValidity.vue?vue&type=template&id=1f117ca0&scoped=true&"
import script from "./CourseValidity.vue?vue&type=script&lang=js&"
export * from "./CourseValidity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f117ca0",
  null
  
)

export default component.exports